import React from "react";
import AntdPageHeader from 'antd/lib/page-header';
import { withError} from '@fishx/tracker';

const PageHeader = (props) => <AntdPageHeader  {...props} />
PageHeader.displayName = 'PageHeader';
export default withError(PageHeader);




// WEBPACK FOOTER //
// ./src/components/page-header/index.tsx